import React, { useState, useEffect } from 'react';
import { getBudgetPlanItems } from './viewServices/budget_api';
import CardBudgetDetailed from './viewComponents/Detailed/CardBudgetDetailed';

const BudgetDetailed = () => {
  const [budgets, setBudgets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function fetchBudgets() {
      setLoading(true);
      setError(null);
      try {
        const res = await getBudgetPlanItems();
        const data = res.data?.results ?? res.data ?? [];
        if (!cancelled) setBudgets(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setError('Failed to fetch budgets.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchBudgets();
    return () => { cancelled = true; };
  }, []);

  return (
    <CardBudgetDetailed budgets={budgets} loading={loading} error={error} />
  );
};

export default BudgetDetailed;
